// extracted by mini-css-extract-plugin
export default {"time_box":"Water_time_box__feX8c","time_label":"Water_time_label__+YiG7","chart_wrapper":"Water_chart_wrapper__4bBPc"};